@import 'variables.scss';

// Exposes the SCSS variables to JS (`import variables from 'styles/variables.module.scss'`).
// Vite only processes the ICSS :export block in CSS modules, hence the .module.scss name.
:export {
  primaryColor: $primary-color;
  primaryLightColor: $primary-light-color;
  secondaryColor: $secondary-color;
  successColor: $success-color;
  yellowColor: $yellow-color;
  redColor: $red-color;
  whiteSmokeColor: $white-smoke-color;
  grayColor: $gray-color;
  grayLightColor: $gray-light-color;
  grayDarkColor: $gray-dark-color;
  whisperGrey: $whisper-grey;
  navbarHeight: $navbar-height;
  pastelGreenColor: $pastel-green-color;
}
